// ============================================================================
// ENUM MASTER HOOKS
// ============================================================================

import { useState, useEffect, useCallback } from 'react';
import { enumService } from 'api/services/enumService';
import type { EnumItem } from 'api/types/enum.types';

export const useEnumsByGroup = (group: string) => {
  const [data, setData] = useState<EnumItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchEnums = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await enumService.getByGroup(group);
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [group]);

  useEffect(() => {
    fetchEnums();
  }, [fetchEnums]);

  return { data, loading, error, refetch: fetchEnums };
};
